/* unplugin-vue-components disabled */import script from "./BatchDepositImport.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchDepositImport.vue?vue&type=script&setup=true&lang=js"

import "./BatchDepositImport.vue?vue&type=style&index=0&id=0514964f&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0514964f"]])

export default __exports__